import type {BridgeBarConfig} from "../config";

export function buildBridgeBarApiUrl(
  baseUrl: string,
  partitionQueryParameter: string,
  config?: BridgeBarConfig
): string {
  const params = new URLSearchParams();
  params.set("partition", partitionQueryParameter);

  if (config) {
    params.set("applicationId", config.applicationId);
    params.set("bridgeEnv", `${config.deployment}/${config.partition}`);
    params.set("sessionId", config.sessionId);
    if (config.language) {
      params.set("language", config.language);
    }
  }

  return `${baseUrl}/user-details/mine?${params.toString()}`;
}
